module.exports = __webpack_public_path__ + "img/stain.a5062751.png";